import Link from 'next/link';

import Card, { CardContent } from '@/components/@base/card';
import Container from '@/components/@base/container';
import { Props } from '@/components/shared/components/cards/banner/text-banner/type';

export default function TextBanner({ link, title, subTitle, buttonText, onClick }: Props) {
  return (
    <Card>
      <CardContent>
        <Container>
          <Link href={link} prefetch={false} onClick={onClick}>
            {title}
          </Link>
          <Link href={link} prefetch={false} onClick={onClick}>
            {subTitle}
          </Link>
        </Container>
        <Link href={link} prefetch={false} onClick={onClick}>
          {buttonText}
        </Link>
      </CardContent>
    </Card>
  );
}
